// Library Methods
import i18next from "i18next";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { UserIcon } from "src/assets/icons";

import tutorialVideosImg from "src/assets/images/operating-manual/instructions-for-use/tutorial-tab.png";
import tutorialVideosFrImg from "src/assets/images/operating-manual/instructions-for-use/tutorial-tab-fr.png";
import operatingManualImg from "src/assets/images/operating-manual/instructions-for-use/operating-manual-tab.png";
import operatingManualFrImg from "src/assets/images/operating-manual/instructions-for-use/operating-manual-tab-fr.png";
// import emrAgentImg from "src/assets/images/operating-manual/instructions-for-use/emr-agent-tab.png";
// import emrAgentFrImg from "src/assets/images/operating-manual/instructions-for-use/emr-agent-tab-fr.png";
import navbarDropdownImg from "src/assets/images/operating-manual/instructions-for-use/navbar-dropdown.png";
import navbarDropdownFrImg from "src/assets/images/operating-manual/instructions-for-use/navbar-dropdown-fr.png";

// Styles
import { UI_SIZES } from "src/constants/uiTokens";

// Config
import { priorityLanguageMap } from "src/config/languages";

const ExternalExams = () => {
  const { t } = useTranslation("operating-manual");

  const currentLang = i18next.language as keyof typeof priorityLanguageMap;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Typography>
        1. {t("Click on ")}
        <IconButton
          sx={{
            width: `${UI_SIZES.iconButtonSize}px`,
            height: `${UI_SIZES.iconButtonSize}px`,
            color: "#FFF",
            backgroundColor: "#202338",
            borderRadius: "4px",
            pointerEvents: "none",
          }}
        >
          <UserIcon />
        </IconButton>
        {t(" in the navigation bar.")}
      </Typography>

      <Typography>2. {t("Click 'Knowledge Hub'.")}</Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={currentLang === "fr" ? navbarDropdownFrImg : navbarDropdownImg}
          width="30%"
          alt="navbar-dropdown"
        />
      </Box>

      <Typography fontWeight={600}>{t("Tab Overview")}</Typography>

      <Typography>1. {t("Tutorial Videos")}</Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={currentLang === "fr" ? tutorialVideosFrImg : tutorialVideosImg}
          width="100%"
          alt="tutorial-videos-tab"
        />
      </Box>
      <Typography>2. {t("Operating Manual")}</Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={currentLang === "fr" ? operatingManualFrImg : operatingManualImg}
          width="100%"
          alt="operating-manual-tab"
        />
      </Box>
    </Box>
  );
};

export default ExternalExams;
